import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemSquare extends DrawingDataItem {
    constructor() {
        super();
        this.typeValue = 'square';
        this.properties = {
            location: undefined
        }
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.location),
        ]
    }

    onMouseDbClick(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.location = {
            x: canvasRelativeX,
            y: canvasRelativeY
        };
        return {
            stillDrawing: false,
            changed: true
        };
    }

    draw(ctx: CanvasRenderingContext2D) {
        const size = this.common.size;
        const location = this.properties.location;
        if (location) {
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.rect(location.x - size / 2, location.y - size / 2, size, size);
            ctx.stroke();
        }
    }
}